/**
 * Copyright (C) 2024 Checkmk GmbH - License: GNU General Public License v2
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */
import { cva } from 'class-variance-authority'

export const simpleIcons = [
  'checkmark',
  'close',
  'reload',
  'tree-closed',
  'main-help',
  'services',
  'external-link',
  'dashboard-grid',
  'developer-resources',
  'drag',
  'frameurl',
  'info-circle',
  'validation-error',
  'disabled',
  'enabled',
  'crit-problem',
  'checkmk-logo-min',
  'export-link',
  'delete',
  'search',
  'checkmark-bare',
  'back',
  'continue',
  'save-to-services',
  'insertdate',
  'alert-crit',
  'alert-warn',
  'alert-up',
  'about-checkmk',
  'check',
  'cross',
  'save',
  'cancel',
  'pending-task',
  'sparkle',
  'history',
  'main-changes',
  'main-setup-active',
  'main-monitoring-active',
  'main-customize-active',
  'info',
  'external',
  'plus',
  'edit',
  'load-graph',
  'filter',
  'toggle-on',
  'toggle-off',
  'help-activated',
  'connection-tests',
  'rulesets',
  'users',
  'assign',
  'backup',
  'contactgroups',
  'learning-checkmk',
  'learning-guide',
  'licensing',
  'lightbulb',
  'check-parameters',
  'sites',
  'folder',
  'networking',
  'aws-logo',
  'azure-vms',
  'gcp',
  'synthetic-monitoring-yellow',
  'opentelemetry',
  'dashboard',
  'dashboard-problems',
  'svc-problems',
  'timeperiods',
  'hostgroups',
  'notifications',
  'analysis',
  'new',
  'copied',
  'global-settings',
  'topic-administration',
  'topic-agents',
  'topic-analyze',
  'topic-applications',
  'topic-bi',
  'topic-change-password',
  'topic-checkmk',
  'topic-events',
  'topic-exporter',
  'topic-general',
  'topic-graphs',
  'topic-history',
  'topic-host',
  'topic-inventory',
  'topic-maintenance',
  'topic-monitoring',
  'topic-my-workplace',
  'topic-network',
  'topic-other',
  'topic-overview',
  'topic-problems',
  'topic-profile',
  'topic-quick-setups',
  'topic-reporting',
  'topic-services',
  'topic-site',
  'topic-system',
  'topic-two-factor',
  'topic-user-interface',
  'topic-users',
  'topic-visualization',
  'topic-synthetic-monitoring',
  'topic-pagetype',
  'topic-search',
  'event-console',
  'graph',
  'view',
  'site-overview',
  'inventory',
  'werk-ack',
  'alerts',
  'static-text',
  'alert-overview',
  'alert-timeline',
  'notification-timeline',
  'percentage-of-service-problems',
  'barplot',
  'scatterplot',
  'single-metric',
  'top-list',
  'gauge',
  'add',
  'user-interface',
  'widget-edit',
  'widget-clone',
  'widget-delete',
  'debian',
  'redhat',
  'windows',
  'custom-snapin'
] as const

export const oneColorIcons = [
  'services',
  'show-more',
  'show-less',
  'search',
  'monitoring',
  'customize',
  'setup',
  'changes',
  'user',
  'help',
  'sidebar'
] as const
export const twoColorIcons = ['aggr'] as const

export const cmkIconVariants = cva('', {
  variants: {
    variant: {
      plain: '',
      inline: 'cmk-icon--inline'
    },
    size: {
      xxsmall: '8px',
      xsmall: '10px',
      small: '12px',
      medium: '15px',
      large: '18px',
      xlarge: '20px',
      xxlarge: '32px',
      xxxlarge: '77px'
    },
    colored: {
      true: '',
      false: 'cmk-icon--colorless'
    }
  },
  defaultVariants: {
    variant: 'plain',
    size: 'medium',
    colored: true
  }
})

export const cmkMultitoneIconVariants = cva('', {
  variants: {
    color: {
      success: 'green',
      hosts: 'blue',
      info: 'blue',
      warning: 'yellow',
      services: 'yellow',
      danger: 'red',
      customization: 'pink',
      others: 'grey',
      users: 'purple',
      specialAgents: 'cyan',
      font: 'font'
    },
    size: {
      xxsmall: '8px',
      xsmall: '10px',
      small: '12px',
      medium: '15px',
      large: '18px',
      xlarge: '20px',
      xxlarge: '32px',
      xxxlarge: '77px'
    }
  },
  defaultVariants: {
    size: 'medium'
  }
})
